import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

import FullWidthSection from '../../styles/FullWidthSection/FullWidthSection';

import SectionImageBlock from './styles/SectionImageBlock';
import TextBlock from './styles/TextBlock';
import SectionTitle from './styles/SectionTitle';

function BuildTogetherSection({ index }) {
  const { formatMessage } = useIntl();
  return (
    <FullWidthSection
      minHeight="0px"
      backgroundColor="white.dark"
    >
      <TextBlock>
        <TextBlock.InnerContainer>
          <SectionTitle
            variant="title"
            intlKey={`cms.businessAccountPage.cardsArea[${index}].title`}
            color="black"
            colorVariant="default"
          />
          <Typography
            variant="subtitle"
            color="black"
            colorVariant="default"
            intlKey={`cms.businessAccountPage.cardsArea[${index}].description`}
          />
        </TextBlock.InnerContainer>
      </TextBlock>
      <SectionImageBlock
        backgroundImage="pj-woman-working/pj-woman-working.jpg"
        alt={formatMessage({ id: 'BUSINESS_ACCOUNT.BUILD_TOGETHER.IMAGE_ALT' })}
        imageWidth="100%"
        imageHeight="100%"
        loading="lazy"
      />
    </FullWidthSection>
  );
}

BuildTogetherSection.propTypes = {
  index: PropTypes.number.isRequired,
};

export default React.memo(BuildTogetherSection);
